<script setup>

// Note: Even though none of these are used, we are still binding these since
// every menu item will have them
const icon = defineModel('icon')
const name = defineModel('name')
const href = defineModel('href')
const viewport = defineModel('viewport')
const meta = defineModel('meta')

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div class="w-full h-full flex items-center justify-center text-sm p-8 text-center">
    {{ __('This menu item has no settings to configure, but you can still reorder it and toggle its visibility for different screen sizes.') }}
  </div>
</template>
